import { InawoGreenLuxeIcon } from "src/components/Icons";

import "./styles.scss";

import { useMutation } from "@apollo/client";
import { useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import Icon from "src/components/Icon";
import { Spinner } from "src/components/Spinner";
import StyledButton from "src/components/StyledButton.tsx";
import { SelectTemplate } from "src/graphql/mutations";
import useAppStore from "src/store/utils";
import TemplatePreview from "../website/Templates/TemplatePreview";

interface TemplateProps {
  id: string;
  name: string;
  image: string;
  // badge: string;
  setIsLuxeFeaturesOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsXclusiveFeaturesOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isLuxeEvent: boolean;
}

const Template = ({
  setIsLuxeFeaturesOpen,
  setIsXclusiveFeaturesOpen,
  id,
  name,
  image,
  isLuxeEvent,
  // badge,
}: TemplateProps) => {
  const navigate = useNavigate();
  const { event, setEvent } = useAppStore((state) => state);

  // const [liked, setLiked] = useState(false);

  // const isLuxeEvent = useContext(AppContext)?.isLuxeEvent;

  const [selectTemplate, { loading }] = useMutation(SelectTemplate, {
    onCompleted() {
      toast.success(<p className="toast">Template selected</p>);
      setEvent({ ...event, template_id: id });
    },
    onError(error) {
      if (error?.message !== "unauthenticated") {
        toast.error(
          <p className="toast">{error?.message ?? "An error occured"}</p>
        );
      } else {
        navigate("/clear");
      }
    },
  });

  const handleChangeTemplate = () => {
    if (id !== event.template_id) {
      if (!isLuxeEvent && id !== "default") {
        setIsLuxeFeaturesOpen(true);
      } else {
        selectTemplate({
          variables: {
            req: {
              event_id: event?.uuid,
              template_id: id,
            },
          },
        });
      }
    }
  };

  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  return (
    <div className="box-border flex flex-col gap-4">
      <div
        className={`image-card relative aspect-[1.5] cursor-pointer rounded-2xl transition duration-500 hover:scale-[1.02]`}
      >
        <Link to={`/website/templates/${id}-demo`}>
          {id === event.template_id && (
            <>
              <div className="absolute -right-2 -top-2 rounded bg-green-600 p-1 text-sm text-white">
                Active
              </div>
            </>
          )}
          <img
            // src={templateImage}
            src={image}
            alt="website-template"
            sizes="(min-width: 1024px) 50vw, 100vw"
            // width="100%"
            // height={"100%"}
            className="h-full w-full rounded-2xl object-cover object-top"
          />
        </Link>
      </div>

      <div className="flex items-center justify-between">
        <div className="">
          <p className="">{name}</p>
          {/* <p className="text-sm text-gray-500">
            {badge === "Exclusive" ? `Limited Edition` : ``}
            </p> */}
        </div>

        {/* <div
          className={`cursor-pointer transition duration-500`}
          onClick={() => {
            setLiked(!liked);
          }}
        >
          <div className={`heart ${liked ? `is-active` : ``}`}></div>
        </div> */}
      </div>

      <div className="mb-4">
        {id === "default" ? (
          <p className="py-[9px] text-[15px] font-medium uppercase tracking-[4.5px] text-[#A9A9A9]">
            default template
          </p>
        ) : (
          <div className="flex items-center gap-[7px] tracking-[4.5px]">
            <span className="text-[15px] font-medium uppercase text-[#A9A9A9]">
              comes with
            </span>
            <InawoGreenLuxeIcon />
          </div>
        )}
      </div>

      <div className="flex">
        <Link to={`/website/templates/${id}-demo`}>
          <StyledButton
            variant="border-black"
            className="mr-2 flex h-9 items-center gap-2 rounded-md border border-gray-400 px-8"
          >
            <span className="">
              <Icon iconName="previewEye" />
            </span>{" "}
            <span>Preview</span>
          </StyledButton>
        </Link>
        <StyledButton
          variant="border-black"
          className={`mr-2 flex h-9 w-20 items-center justify-center gap-2 rounded-md border border-gray-400 ${id === event.template_id ? `cursor-not-allowed opacity-50` : ``}`}
          disabled={id === event.template_id}
          onClick={handleChangeTemplate}
        >
          {loading ? <Spinner /> : `Use`}
        </StyledButton>
      </div>
      {/* <DialogModal>
        <div className="">Hello there</div>
      </DialogModal> */}
      <TemplatePreview show={isPreviewOpen} setShow={setIsPreviewOpen} />
    </div>
  );
};

export default Template;
